<core-generic-table [dataInput]="vessels()" [endpoint]="endpoint" [listTitle]="'vessels.title' | translate"
  [columns]="columns" [customActions]="customActions" [modalTabs]="modalFields()" [actions]="actions"
  [globalActions]="globalActions" [showFilter]="false" [showSelection]="false" [showActions]="true"
  [showCreateButton]="true" [enablePagination]="true" [modelFactory]="vesselsModelFactory"
  class="o-layout__section c-table--scroll"></core-generic-table>